var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.908,
    height: 29.09,
    viewBox: "0 0 69.908 29.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-06-14T113109.730",
    "data-name": "svgexport-6 - 2022-06-14T113109.730",
    transform: "translate(0 -149.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15860",
    "data-name": "Group 15860",
    transform: "translate(0 149.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27395",
    "data-name": "Path 27395",
    d: "M420.773,203.32c0-4.971-2.408-8.894-7.01-8.894-4.622,0-7.418,3.923-7.418,8.855,0,5.845,3.3,8.8,8.039,8.8a10.827,10.827,0,0,0,5.379-1.262v-3.884A10.311,10.311,0,0,1,415.006,208c-1.884,0-3.554-.66-3.767-2.952h9.5C420.734,204.8,420.773,203.786,420.773,203.32Zm-9.593-1.845c0-2.194,1.34-3.107,2.563-3.107,1.185,0,2.447.913,2.447,3.107Z",
    transform: "translate(-350.865 -188.29)",
    fill: "#042e6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27396",
    "data-name": "Path 27396",
    d: "M298.76,194.426a5.486,5.486,0,0,0-3.806,1.515l-.252-1.2h-4.272v22.643l4.855-1.029.019-5.5a5.468,5.468,0,0,0,3.437,1.223c3.476,0,6.641-2.8,6.641-8.952C305.362,197.494,302.158,194.426,298.76,194.426Zm-1.165,13.38a2.9,2.9,0,0,1-2.291-.913l-.019-7.2a2.89,2.89,0,0,1,2.311-.952c1.767,0,2.991,1.981,2.991,4.525C300.585,205.864,299.381,207.806,297.595,207.806Z",
    transform: "translate(-250.775 -188.29)",
    fill: "#042e6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27397",
    "data-name": "Path 27397",
    d: "M241.5,154.473l4.874-1.049v-3.942l-4.874,1.029Z",
    transform: "translate(-208.53 -149.482)",
    fill: "#042e6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29940",
    "data-name": "Rectangle 29940",
    width: 4.874,
    height: 16.992,
    transform: "translate(32.973 6.466)",
    fill: "#042e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27398",
    "data-name": "Path 27398",
    d: "M174.752,197.011l-.311-1.437h-4.194v16.992H175.1V201.05a3.425,3.425,0,0,1,3.69-1.01v-4.466A3.3,3.3,0,0,0,174.752,197.011Z",
    transform: "translate(-147.002 -189.108)",
    fill: "#042e6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27399",
    "data-name": "Path 27399",
    d: "M102.042,165.98,97.3,166.99l-.019,15.555a4.879,4.879,0,0,0,5.03,4.991,7.5,7.5,0,0,0,3.4-.641v-3.942c-.621.252-3.69,1.146-3.69-1.728V174.33h3.69v-4.136h-3.69Z",
    transform: "translate(-84.001 -163.727)",
    fill: "#042e6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27400",
    "data-name": "Path 27400",
    d: "M4.913,199.688c0-.757.621-1.049,1.651-1.049a10.831,10.831,0,0,1,4.816,1.243v-4.564a12.808,12.808,0,0,0-4.816-.893c-3.942,0-6.564,2.058-6.564,5.5,0,5.36,7.379,4.505,7.379,6.816,0,.893-.777,1.185-1.864,1.185a12.088,12.088,0,0,1-5.3-1.553v4.622a13.462,13.462,0,0,0,5.3,1.107c4.039,0,6.816-2,6.816-5.476C12.312,200.834,4.913,201.863,4.913,199.688Z",
    transform: "translate(0 -188.29)",
    fill: "#042e6f",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripe-icon.7acd6bfba042bc89664890e60c6b7ef5.svg";
export { ForwardRef as ReactComponent };